'use client';
import type {TFunction} from 'i18next';
import {createContext} from 'react';

import type RegistrationStore from '@/app/[locale]/(login&registration)/registration/store/registrationStore';
import type {CompanyProfileContextType} from '@/app/[locale]/company/[company]/account-admin/public-profile/CompanyProfileLayoutWrapper';
import type RegisteredOrgsStore from '@/app/[locale]/platform/companies/store/RegisteredOrgsStore';
import type IPCaptchaStore from '@/app/[locale]/platform/platform-testing/ip-captcha/store/ipCaptchaStore';
import type PhoneNumberAliasStore from '@/app/[locale]/platform/platform-testing/phone-number-alias/store/phoneNumberAliasStore';
import type {SessionStore} from '@/app/[locale]/platform/sessions/store/SessionStore';
import type PlatformStore from '@/app/[locale]/platform/store/platformStore';
import type RegisteredUsersStore from '@/app/[locale]/platform/users/store/registeredUsersStore';
import type {ProfileContextType} from '@/app/[locale]/user/my-account/public-profile/ProfileLayoutWrapper';
import type AccountSecurityStore from '@/app/[locale]/user/settings/account-security/AccountSecurityStore';
import type {CommonHeaderContextType} from '@/components/base/CommonHeader';
import type {ShareSettingsModalContextType} from '@/components/contacts/modals/ShareSettingsModalProvider';
import type ContactsStore from '@/components/contacts/store/contactsStore';
import type {FileDirectoryContextType} from '@/components/files/FileDirectoryContextProvider';
import type CompanyStore from '@/store/CompanyStore';
import type PSecurityPolicyStore from '@/store/PolicyStore';

export type TranslationContextProps = {
  trans: TFunction<string, undefined>;
};

export const CompanyStoreContext = createContext({} as CompanyStore);
export const AccountSecurityStoreContext = createContext({} as AccountSecurityStore);
export const RegistrationStoreContext = createContext({} as RegistrationStore);
export const IPCaptchaContext = createContext({} as IPCaptchaStore);
export const PhoneNumberAliasContext = createContext({} as PhoneNumberAliasStore);
export const SessionStoreContext = createContext({} as SessionStore);
export const RegisteredOrgsStoreContext = createContext({} as RegisteredOrgsStore);
export const TranslationContext = createContext({} as TranslationContextProps);
export const PlatformSecurityPolicyContext = createContext({} as PSecurityPolicyStore);
export const GlidTranslationContext = createContext({} as TranslationContextProps);
export const PlatformStoreContext = createContext({} as PlatformStore);
export const RegisteredUsersContext = createContext({} as RegisteredUsersStore);
export const ContactsDirectoryContext = createContext({} as ContactsStore);
export const PublicProfileContext = createContext({} as ProfileContextType);
export const CompanyPublicProfileContext = createContext({} as CompanyProfileContextType);
export const ShareSettingsModalContext = createContext({} as ShareSettingsModalContextType);
export const CommonHeaderContext = createContext({} as CommonHeaderContextType);
export const FileDirectoryContext = createContext({} as FileDirectoryContextType);
